<div dwCol="4">
    <dw-message [message]="message"></dw-message>
</div>
<div dwRow>
    <div dwCol="6">
        <label class="label">Job Numbers</label>
        <dw-auto-complete-lookup type="text" placeholder="Start typing to search" [lookupId]="jobNumberLookupId" [(ngModel)]="selectedJobNumberId">
        </dw-auto-complete-lookup>
    </div>
    <div dwCol="6">
        <button class="fa fa-plus-circle btn btn-success m-2 addButton" (click)="addJobNumber()"> Add</button>
    </div>
</div>

<div dwRow class="kickoffGrid">
    <div dwCol="12">        
            <table class="table">
                <thead class="thead-light">
                    <tr>
                        <th>
                            Job Number
                        </th>
                        <th>
                            Project Name
                        </th>
                        <th>
                            Project Manager
                        </th>
                        <th>
                            Customer Name
                        </th>
                        <th>
                            Project Start Date
                        </th>
                        <th>
                            Project End Date
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of jobNumberData">
                        <td>
                            {{item?.JobNumber}}
                        </td>
                        <td>
                            {{item?.JobName}}
                        </td>
                        <td>
                            {{item?.ProjectMgr1UserIdDisplay}}
                        </td>
                        <td>
                            {{item?.CustomerName}}
                        </td>
                        <td>
                            {{item?.EstimatedStartDate | date}}
                        </td>
                        <td>
                            {{item?.EstimatedEndDate | date}}
                        </td>
                    </tr>
                </tbody>
            </table>

        <div class="noData" style="max-width:800px" *ngIf="!jobNumberData || jobNumberData.length == 0">
            No Job Numbers To Show
        </div>

    </div>
</div>